import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetQueryParams } from '@qapline/helpers';
import { ELanguage } from '@qapline/translations';
import { useLocalStorage } from '@uidotdev/usehooks';

export const useLanguage = () => {
    const { i18n } = useTranslation();
    const [storedLang, setLanguage] = useLocalStorage<ELanguage>('language', ELanguage.cs);
    const { lang: queryLang } = useGetQueryParams<{ lang: string }>();

    const handleChangeLanguage = useCallback(
        (lang: string) => {
            setLanguage(lang as ELanguage);
            changeLanguage(lang);
        },
        [setLanguage],
    );
    const changeLanguage = useCallback(
        (lang: string) => {
            i18n.changeLanguage(lang).catch(() => {
                console.warn(`Language "${lang}" is not supported, falling back to default language.`);
            });
        },
        [i18n],
    );

    useEffect(() => {
        changeLanguage(storedLang);
    }, [storedLang]);

    useEffect(() => {
        if (!queryLang) return;
        changeLanguage(queryLang);
    }, [queryLang]);

    return {
        i18n,
        currentLanguage: i18n.language,
        changeLanguage: handleChangeLanguage,
    };
};
